module.exports = __webpack_public_path__ + "img/yq-pic6.ac6e3df1.png";